import {
    applicationOnError,
    getCompanySuccess,
    getConfigCalendarDaySuccess,
    getConfigDayOffCodeSuccess,
    getConfigOptionalFieldSuccess
} from './actions';
import { cycleStatusesReceived, cycleTypesReceived, cyclesReceived } from '../cycles/actions';
import { prestationGroupsReceived, prestationsReceived } from '../prestations/actions';

import { articleReceived } from '../articles/actions';
import { attachmentReceived } from '../attachment/actions';
import axios from 'axios';
import { dayoffReceived } from '../dayoff/actions';
import { depositTicketReceived } from '../depositTickets/actions';
import { employeesReceived } from '../employees/actions';
import { eventsReceived, eventsToValidateReceived } from '../events/actions';
import { formReceived } from '../forms/actions';
import { getCustomerSuccess } from '../customers/actions';
import { getFoldersSuccess } from '../folders/actions';
import { getGroupRisksSuccess } from '../groupRisks/actions';
import { getMaterialSuccess } from '../materials/actions';
import { getSecurityReports } from '../securityReports/actions';
import { getSiteSuccess } from '../sites/actions';
import i18n from 'i18next';
import localforage from 'localforage';
import { materialTypesReceived } from '../materialTypes/actions';
import { ordersReceived } from '../orders/actions';
import { siteTicketReceived } from '../siteTickets/actions';
import { siteTrashDepositReceived } from '../siteTrashDeposit/actions';
import store from '../../store';
import { suppliersReceived } from '../suppliers/actions';
import { timeslotProfileReceived } from '../timeslotProfiles/actions';
import { toast } from 'react-toastify';
import { typeDocReceived } from '../typedoc/actions';
import { usersReceived } from '../users/actions';

const { dispatch } = store;

// Function to log user access rights
const logUserAccessRights = (users) => {
    const state = store.getState();
    const authState = state.auth;
    const logguedUser = users.find(user => user.id === authState.user_id);
    
    if (!logguedUser) return;

    const accessRights = [
        { name: 'Planning', bit: 0, mask: 1 },
        { name: 'Documents Salariés', bit: 1, mask: 2 },
        { name: 'Congés', bit: 2, mask: 4 },
        { name: 'Interventions', bit: 3, mask: 8 },
        { name: 'Matériel', bit: 4, mask: 16 },
        { name: 'Chantiers', bit: 5, mask: 32 },
        { name: 'Validation', bit: 6, mask: 64 },
        { name: 'Planning Chantier', bit: 7, mask: 128 },
        { name: 'Consommations', bit: 8, mask: 256 },
        { name: 'Bons d\'enlèvement', bit: 9, mask: 512 },
        { name: 'Bons de livraison', bit: 10, mask: 1024 },
        { name: 'Validation chantier', bit: 11, mask: 2048 },
        { name: 'Approvisionnements', bit: 12, mask: 4096 },
        { name: 'Sécurité', bit: 13, mask: 8192 },
        { name: 'Situations Dangereuses', bit: 14, mask: 16384 },
        { name: 'Documents Matériel', bit: 15, mask: 32768 },
        { name: 'Compteur Kilométrique', bit: 16, mask: 65536 }
    ];

    // eslint-disable-next-line no-console
    console.log('\n%c🔐 DROITS UTILISATEUR', 'color: #4CAF50; font-weight: bold; font-size: 14px;');
    // eslint-disable-next-line no-console
    console.log(`%cUtilisateur: ${logguedUser.firstname} ${logguedUser.lastname}`, 'color: #2196F3; font-weight: bold;');
    // eslint-disable-next-line no-console
    console.log(`%cModule Access Mask: ${logguedUser.module_access_mask}`, 'color: #2196F3;');
    // eslint-disable-next-line no-console
    console.log('%c─────────────────────────────────────────────', 'color: #999;');

    accessRights.forEach(right => {
        const hasAccess = (logguedUser.module_access_mask & right.mask) > 0;
        const status = hasAccess ? '✓ OUI' : '✗ NON';
        const color = hasAccess ? '#4CAF50' : '#f44336';
        // eslint-disable-next-line no-console
        console.log(`%cAccès ${right.name} (bit ${right.bit}): ${status}`, `color: ${color};`);
    });

    // eslint-disable-next-line no-console
    console.log('%c─────────────────────────────────────────────\n', 'color: #999;');
};

export const getResourceSource = () => {
    return store.getState().core.offlineMode ? 'offline' : 'api';
};

export const updateApp = () => {
    const resourceLF = localforage.createInstance({ name: 'optim_resources'});
    switch(getResourceSource()) {
        case 'api':
            return axios.get('/referential').then(response => {
                const data = response.data;
                dispatch(usersReceived(data.users));
                logUserAccessRights(data.users);
                dispatch(getCompanySuccess(data.company));
                dispatch(employeesReceived(data.employees));
                dispatch(getConfigDayOffCodeSuccess(data.dayOffCodes));
                dispatch(getConfigOptionalFieldSuccess(data.optionalFields));
                dispatch(getConfigCalendarDaySuccess(data.calendarDays));
                dispatch(getSiteSuccess(data.sites));
                dispatch(getCustomerSuccess(data.customers));
                dispatch(prestationsReceived(data.prestations));
                dispatch(prestationGroupsReceived(data.prestationGroups));
                dispatch(articleReceived(data.articles));
                dispatch(cycleStatusesReceived(data.cycleStatuses));
                dispatch(cycleTypesReceived(data.cycleTypes));
                dispatch(getMaterialSuccess(data.materials));
                dispatch(getFoldersSuccess(data.folders));
                dispatch(suppliersReceived(data.suppliers));
                dispatch(typeDocReceived(data.typedoc));
                dispatch(timeslotProfileReceived(data.timeslotProfiles));
                dispatch(getGroupRisksSuccess(data.groupRisks));
                dispatch(materialTypesReceived(data.materialTypes));
                dispatch(attachmentReceived(data.attachments));
                dispatch(formReceived(data.forms));
            }).catch(function(error) {
                if (error?.response?.data?.message === 'maximum_user_reached') {
                    dispatch(applicationOnError('maximum_user_reached'));
                    toast.error(i18n.t('app:maximum_connection_reached_block'), { autoClose: false, closeButton: false, closeOnClick: false });
                } else {
                    toast.error(i18n.t('common:cannot_bootstrap_app'), { autoClose: false, closeButton: false, closeOnClick: false });
                }
                dispatch(applicationOnError(true));
            });
        case 'offline':
            return Promise.all([
                resourceLF.getItem('users').then(res => {
                    dispatch(usersReceived(res.list));
                    logUserAccessRights(res.list);
                }),
                resourceLF.getItem('app').then(res => dispatch(getCompanySuccess(res.company))),
                resourceLF.getItem('employees').then(res => dispatch(employeesReceived(res))),
                resourceLF.getItem('app').then(res => dispatch(getConfigDayOffCodeSuccess(res.dayOffCodes))),
                resourceLF.getItem('app').then(res => dispatch(getConfigOptionalFieldSuccess(res.optionnalFields))),
                resourceLF.getItem('app').then(res => dispatch(getConfigCalendarDaySuccess(res.calendarDays))),
                resourceLF.getItem('sites').then(res => dispatch(getSiteSuccess(res.list))),
                resourceLF.getItem('customers').then(res => dispatch(getCustomerSuccess(res.list))),
                resourceLF.getItem('events').then(res => dispatch(eventsReceived(res.all))),
                resourceLF.getItem('prestations').then(res => dispatch(prestationsReceived(res.all))),
                resourceLF.getItem('prestations').then(res => dispatch(prestationGroupsReceived(res.groups))),
                resourceLF.getItem('dayoff').then(res => dispatch(dayoffReceived(res.all))),
                resourceLF.getItem('articles').then(res => dispatch(articleReceived(res.all))),
                resourceLF.getItem('materials').then(res => dispatch(getMaterialSuccess(res.list))),
                resourceLF.getItem('folders').then(res => dispatch(getFoldersSuccess(res.list))),
                resourceLF.getItem('suppliersTickets').then(res => dispatch(suppliersReceived(res.all))),
                resourceLF.getItem('depositTickets').then(res => dispatch(depositTicketReceived(res.all))),
                resourceLF.getItem('orders').then(res => dispatch(ordersReceived(res.all))),
                resourceLF.getItem('siteTickets').then(res => dispatch(siteTicketReceived(res.all))),
                resourceLF.getItem('typedoc').then(res => dispatch(typeDocReceived(res.all))),
                resourceLF.getItem('timeslotProfiles').then(res => dispatch(timeslotProfileReceived(res.all))),
                resourceLF.getItem('group_risks').then(res => dispatch(getGroupRisksSuccess(res.all))),
                resourceLF.getItem('securityReports').then(res => dispatch(getSecurityReports(res.all))),
                resourceLF.getItem('materialTypes').then(res => dispatch(materialTypesReceived(res.all))),
                resourceLF.getItem('attachment').then(res => dispatch(attachmentReceived(res.all))),
            ]);
        default:
            throw new Error('Unknow resource source');
    }
};

// Cooldown mechanism to avoid duplicate API calls
const _cooldowns = {};
const REFRESH_COOLDOWN_MS = 30000;
const UPDATE_COOLDOWN_MS = 5000;
const _isCoolingDown = (key) => _cooldowns[key] && (Date.now() - _cooldowns[key] < UPDATE_COOLDOWN_MS);
const _setCooldown = (key) => { _cooldowns[key] = Date.now(); };

let _refreshPromise = null;
export const refreshReferential = () => {
    if (getResourceSource() !== 'api') return Promise.resolve();
    if (_refreshPromise) return _refreshPromise;
    if (_cooldowns._referential && (Date.now() - _cooldowns._referential < REFRESH_COOLDOWN_MS)) return Promise.resolve();
    _refreshPromise = axios.get('/referential').then(response => {
        const data = response.data;
        const state = store.getState();
        dispatch(usersReceived(data.users));
        dispatch(getCompanySuccess(data.company));
        dispatch(employeesReceived(data.employees));
        dispatch(getConfigDayOffCodeSuccess(data.dayOffCodes));
        dispatch(getConfigOptionalFieldSuccess(data.optionalFields));
        dispatch(getConfigCalendarDaySuccess(data.calendarDays));
        dispatch(getCustomerSuccess(data.customers));
        dispatch(prestationsReceived(data.prestations));
        dispatch(prestationGroupsReceived(data.prestationGroups));
        dispatch(articleReceived(data.articles));
        dispatch(cycleStatusesReceived(data.cycleStatuses));
        dispatch(cycleTypesReceived(data.cycleTypes));
        dispatch(getFoldersSuccess(data.folders));
        dispatch(suppliersReceived(data.suppliers));
        dispatch(typeDocReceived(data.typedoc));
        dispatch(timeslotProfileReceived(data.timeslotProfiles));
        dispatch(getGroupRisksSuccess(data.groupRisks));
        dispatch(materialTypesReceived(data.materialTypes));
        dispatch(attachmentReceived(data.attachments));
        dispatch(formReceived(data.forms));
        // Merge sites: update referential metadata but keep existing detailed data
        const mergedSites = data.sites.map(refSite => {
            const existing = state.sites.list.find(s => s.id === refSite.id);
            if (!existing) return refSite;
            return { ...refSite, ...existing };
        });
        dispatch(getSiteSuccess(mergedSites));
        // Merge materials: update referential metadata but keep existing detailed data
        const mergedMaterials = data.materials.map(refMat => {
            const existing = state.materials.list.find(m => m.id === refMat.id);
            if (!existing) return refMat;
            return { ...refMat, ...existing };
        });
        dispatch(getMaterialSuccess(mergedMaterials));
    }).catch(() => {
        // Silent fail - referential refresh is non-critical
    }).finally(() => {
        _refreshPromise = null;
        _cooldowns._referential = Date.now();
    });
    return _refreshPromise;
};

export const updateEventsToValidate = () => {
    if (getResourceSource() !== 'api') return Promise.resolve();
    if (_isCoolingDown('updateEventsToValidate')) return Promise.resolve();
    _setCooldown('updateEventsToValidate');
    return axios.get('/event/to-validate').then(response => {
        dispatch(eventsToValidateReceived(response.data));
    }).catch(() => {
        // Silent fail
    });
};

export const updateSite = (siteId) => {
    if (!siteId) return Promise.resolve();
    const cooldownKey = `updateSite_${siteId}`;
    if (getResourceSource() === 'api' && _isCoolingDown(cooldownKey)) return Promise.resolve();
    const resourceLF = localforage.createInstance({ name: 'optim_resources'});
    switch(getResourceSource()) {
        case 'api': {
            _setCooldown(cooldownKey);
            const siteParam = siteId ? `?site_id=${siteId}` : '';
            const promises = [
                axios.get(`/event${siteParam}`),
                axios.get(`/deposit_ticket${siteParam}`),
                axios.get(`/order${siteParam}`),
                axios.get(`/site_ticket${siteParam}`),
                axios.get(`/security-report${siteParam}`),
                axios.get(`/trash-deposit${siteParam}`),
            ];
            if (siteId) {
                promises.push(axios.get(`/site/${siteId}`));
            }
            return Promise.all(promises).then(values => {
                dispatch(eventsReceived(values[0].data));
                dispatch(depositTicketReceived(values[1].data));
                dispatch(ordersReceived(values[2].data));
                dispatch(siteTicketReceived(values[3].data));
                dispatch(getSecurityReports(values[4].data));
                dispatch(siteTrashDepositReceived(values[5].data));
                if (siteId && values[6]) {
                    const state = store.getState();
                    const sites = state.sites.list.map(s =>
                        s.id === siteId ? values[6].data : s
                    );
                    dispatch(getSiteSuccess(sites));
                }
            }).catch(function(error) {
                if (error?.response?.data?.message === 'maximum_user_reached') {
                    dispatch(applicationOnError('maximum_user_reached'));
                    toast.error(i18n.t('app:maximum_connection_reached_block'), { autoClose: false, closeButton: false, closeOnClick: false });
                }
            });
        }
        case 'offline':
            return Promise.all([
                resourceLF.getItem('employees').then(res => dispatch(employeesReceived(res))),
                resourceLF.getItem('app').then(res => dispatch(getConfigCalendarDaySuccess(res.calendarDays))),
                resourceLF.getItem('sites').then(res => dispatch(getSiteSuccess(res.list))),
                resourceLF.getItem('customers').then(res => dispatch(getCustomerSuccess(res.list))),
                resourceLF.getItem('events').then(res => dispatch(eventsReceived(res.all))),
                resourceLF.getItem('prestations').then(res => dispatch(prestationsReceived(res.all))),
                resourceLF.getItem('prestations').then(res => dispatch(prestationGroupsReceived(res.groups))),
                resourceLF.getItem('articles').then(res => dispatch(articleReceived(res.all))),
                resourceLF.getItem('materials').then(res => dispatch(getMaterialSuccess(res.list))),
                resourceLF.getItem('folders').then(res => dispatch(getFoldersSuccess(res.list))),
                resourceLF.getItem('suppliersTickets').then(res => dispatch(suppliersReceived(res.all))),
                resourceLF.getItem('depositTickets').then(res => dispatch(depositTicketReceived(res.all))),
                resourceLF.getItem('siteTickets').then(res => dispatch(siteTicketReceived(res.all))),
                resourceLF.getItem('trashDeposits').then(res => dispatch(siteTrashDepositReceived(res.all))),
                resourceLF.getItem('securityReports').then(res => dispatch(getSecurityReports(res.all))),
                resourceLF.getItem('materialTypes').then(res => dispatch(materialTypesReceived(res.all))),
            ]);
        default:
            throw new Error('Unknow resource source');
    }
};

export const updateEmployee = (employeeId) => {
    if (!employeeId) return Promise.resolve();
    const cooldownKey = `updateEmployee_${employeeId}`;
    if (getResourceSource() === 'api' && _isCoolingDown(cooldownKey)) return Promise.resolve();
    const resourceLF = localforage.createInstance({ name: 'optim_resources'});
    switch(getResourceSource()) {
        case 'api': {
            _setCooldown(cooldownKey);
            const employeeParam = employeeId ? `?employee_id=${employeeId}` : '';
            return Promise.all([
                axios.get(`/event${employeeParam}`),
                axios.get(`/dayoff${employeeParam}`),
            ]).then(values => {
                dispatch(eventsReceived(values[0].data));
                dispatch(dayoffReceived(values[1].data));
            }).catch(function(error) {
                if (error?.response?.data?.message === 'maximum_user_reached') {
                    dispatch(applicationOnError('maximum_user_reached'));
                    toast.error(i18n.t('app:maximum_connection_reached_block'), { autoClose: false, closeButton: false, closeOnClick: false });
                }
            });
        }
        case 'offline':
            return Promise.all([
                resourceLF.getItem('employees').then(res => dispatch(employeesReceived(res))),
                resourceLF.getItem('app').then(res => dispatch(getConfigCalendarDaySuccess(res.calendarDays))),
                resourceLF.getItem('sites').then(res => dispatch(getSiteSuccess(res.list))),
                resourceLF.getItem('customers').then(res => dispatch(getCustomerSuccess(res.list))),
                resourceLF.getItem('events').then(res => dispatch(eventsReceived(res.all))),
                resourceLF.getItem('prestations').then(res => dispatch(prestationsReceived(res.all))),
                resourceLF.getItem('prestations').then(res => dispatch(prestationGroupsReceived(res.groups))),
                resourceLF.getItem('dayoff').then(res => dispatch(dayoffReceived(res.all))),
                resourceLF.getItem('materials').then(res => dispatch(getMaterialSuccess(res.list))),
                resourceLF.getItem('folders').then(res => dispatch(getFoldersSuccess(res.list))),
                resourceLF.getItem('securityReports').then(res => dispatch(getSecurityReports(res.all))),
            ]);
        default:
            throw new Error('Unknow resource source');
    }
};

export const updateMaterial = (materialId) => {
    if (!materialId) return Promise.resolve();
    const cooldownKey = `updateMaterial_${materialId}`;
    if (getResourceSource() === 'api' && _isCoolingDown(cooldownKey)) return Promise.resolve();
    const resourceLF = localforage.createInstance({ name: 'optim_resources'});
    switch(getResourceSource()) {
        case 'api': {
            _setCooldown(cooldownKey);
            const url = materialId ? `/material/${materialId}` : '/material';
            return axios.get(url).then(response => {
                if (materialId) {
                    const state = store.getState();
                    const materials = state.materials.list.map(m =>
                        m.id === materialId ? response.data : m
                    );
                    dispatch(getMaterialSuccess(materials));
                } else {
                    dispatch(getMaterialSuccess(response.data));
                }
            }).catch(function(error) {
                if (error?.response?.data?.message === 'maximum_user_reached') {
                    dispatch(applicationOnError('maximum_user_reached'));
                    toast.error(i18n.t('app:maximum_connection_reached_block'), { autoClose: false, closeButton: false, closeOnClick: false });
                }
            });
        }
        case 'offline':
            return Promise.all([
                resourceLF.getItem('materials').then(res => dispatch(getMaterialSuccess(res.list))),
            ]);
        default:
            throw new Error('Unknow resource source');
    }
};

export const updateCycle = () => {
    if (getResourceSource() === 'api' && _isCoolingDown('updateCycle')) return Promise.resolve();
    switch(getResourceSource()) {
        case 'api':
            _setCooldown('updateCycle');
            return axios.get('/cycle').then(response => {
                dispatch(cyclesReceived(response.data));
            }).catch(function(error) {
                if (error?.response?.data?.message === 'maximum_user_reached') {
                    dispatch(applicationOnError('maximum_user_reached'));
                    toast.error(i18n.t('app:maximum_connection_reached_block'), { autoClose: false, closeButton: false, closeOnClick: false });
                }
            });
        case 'offline':
            // no cycle validation online
            return Promise.all([]);
        default:
            throw new Error('Unknow resource source');
    }
};

export const updateDepositTicket = (siteId) => {
    if (!siteId) return Promise.resolve();
    const cooldownKey = `updateDepositTicket_${siteId}`;
    if (getResourceSource() === 'api' && _isCoolingDown(cooldownKey)) return Promise.resolve();
    const resourceLF = localforage.createInstance({ name: 'optim_resources'});
    switch(getResourceSource()) {
        case 'api': {
            _setCooldown(cooldownKey);
            const siteParam = siteId ? `?site_id=${siteId}` : '';
            return axios.get(`/deposit_ticket${siteParam}`).then(response => {
                dispatch(depositTicketReceived(response.data));
            }).catch(function(error) {
                if (error?.response?.data?.message === 'maximum_user_reached') {
                    dispatch(applicationOnError('maximum_user_reached'));
                    toast.error(i18n.t('app:maximum_connection_reached_block'), { autoClose: false, closeButton: false, closeOnClick: false });
                }
            });
        }
        case 'offline':
            return Promise.all([
                resourceLF.getItem('depositTickets').then(res => dispatch(depositTicketReceived(res.all))),
            ]);
        default:
            throw new Error('Unknow resource source');
    }
};

export const updateSiteTrashDeposit = (siteId) => {
    if (!siteId) return Promise.resolve();
    const cooldownKey = `updateSiteTrashDeposit_${siteId}`;
    if (getResourceSource() === 'api' && _isCoolingDown(cooldownKey)) return Promise.resolve();
    const resourceLF = localforage.createInstance({ name: 'optim_resources'});
    switch(getResourceSource()) {
        case 'api': {
            _setCooldown(cooldownKey);
            const siteParam = siteId ? `?site_id=${siteId}` : '';
            return axios.get(`/trash-deposit${siteParam}`).then(response => {
                dispatch(siteTrashDepositReceived(response.data));
            }).catch(function(error) {
                if (error?.response?.data?.message === 'maximum_user_reached') {
                    dispatch(applicationOnError('maximum_user_reached'));
                    toast.error(i18n.t('app:maximum_connection_reached_block'), { autoClose: false, closeButton: false, closeOnClick: false });
                }
            });
        }
        case 'offline':
            return Promise.all([
                resourceLF.getItem('trashDesposits').then(res => dispatch(depositTicketReceived(res.all))),
            ]);
        default:
            throw new Error('Unknow resource source');
    }
};

export const updateSiteTicket = (siteId) => {
    if (!siteId) return Promise.resolve();
    const cooldownKey = `updateSiteTicket_${siteId}`;
    if (getResourceSource() === 'api' && _isCoolingDown(cooldownKey)) return Promise.resolve();
    const resourceLF = localforage.createInstance({ name: 'optim_resources'});
    switch(getResourceSource()) {
        case 'api': {
            _setCooldown(cooldownKey);
            const siteParam = siteId ? `?site_id=${siteId}` : '';
            return axios.get(`/site_ticket${siteParam}`).then(response => {
                dispatch(siteTicketReceived(response.data));
            }).catch(function(error) {
                if (error?.response?.data?.message === 'maximum_user_reached') {
                    dispatch(applicationOnError('maximum_user_reached'));
                    toast.error(i18n.t('app:maximum_connection_reached_block'), { autoClose: false, closeButton: false, closeOnClick: false });
                }
            });
        }
        case 'offline':
            return Promise.all([
                resourceLF.getItem('siteTickets').then(res => dispatch(siteTicketReceived(res.all))),
            ]);
        default:
            throw new Error('Unknow resource source');
    }
};

export const updateUser = () => {
    if (getResourceSource() === 'api' && _isCoolingDown('updateUser')) return Promise.resolve();
    const resourceLF = localforage.createInstance({ name: 'optim_resources'});
    switch(getResourceSource()) {
        case 'api':
            _setCooldown('updateUser');
            return Promise.all([
                axios.get('/user')
            ]).then(values => {
                dispatch(usersReceived(values[0].data));
            }).catch(function(error) {
                if (error?.response?.data?.message === 'maximum_user_reached') {
                    dispatch(applicationOnError('maximum_user_reached'));
                    toast.error(i18n.t('app:maximum_connection_reached_block'), { autoClose: false, closeButton: false, closeOnClick: false });
                // } else {
                    // toast.error(i18n.t('common:cannot_bootstrap_app'), { autoClose: false, closeButton: false, closeOnClick: false });
                }
                // dispatch(applicationOnError(true));
            // }).finally(() => {
                // stub
            });
        case 'offline':
            return Promise.all([
                resourceLF.getItem('siteTickets').then(res => dispatch(siteTicketReceived(res.all))),
            ]);
        default:
            throw new Error('Unknow resource source');
    }
};
